export default __webpack_public_path__ + "bdee0909562ec324f10f4c9690a9231e.jpg";